module.exports = __webpack_public_path__ + "static/media/calendar.a42efc78.svg";